/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeleteCompanyApiRateLimitRequest
 */
export interface DeleteCompanyApiRateLimitRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteCompanyApiRateLimitRequest
   */
  endpoint: string;
}

/**
 * Check if a given object implements the DeleteCompanyApiRateLimitRequest interface.
 */
export function instanceOfDeleteCompanyApiRateLimitRequest(
  value: object,
): value is DeleteCompanyApiRateLimitRequest {
  if (!("endpoint" in value) || value["endpoint"] === undefined) return false;
  return true;
}

export function DeleteCompanyApiRateLimitRequestFromJSON(
  json: any,
): DeleteCompanyApiRateLimitRequest {
  return DeleteCompanyApiRateLimitRequestFromJSONTyped(json, false);
}

export function DeleteCompanyApiRateLimitRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DeleteCompanyApiRateLimitRequest {
  if (json == null) {
    return json;
  }
  return {
    endpoint: json["endpoint"],
  };
}

export function DeleteCompanyApiRateLimitRequestToJSON(
  json: any,
): DeleteCompanyApiRateLimitRequest {
  return DeleteCompanyApiRateLimitRequestToJSONTyped(json, false);
}

export function DeleteCompanyApiRateLimitRequestToJSONTyped(
  value?: DeleteCompanyApiRateLimitRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    endpoint: value["endpoint"],
  };
}
